import { useDispatch } from "react-redux";
import { resetAssetsSlice } from "../app/slices/AssetsSlice";
import { setLogout } from "../app/slices/AuthenticationSlice";
import { Roles, UsePlayItAuthentication } from "@playit/shared-authentication";
import { AuthenticationService } from "../services/AuthenticationService";

export const UseLogout = () => {
  const dispatch = useDispatch();

  const onLogout = () => {
    // logout
    AuthenticationService.Logout();

    // clear slice
    dispatch(setLogout());

    // clear assets
    dispatch(resetAssetsSlice());
  };

  return { onLogout } as const;
};
